module.exports = __webpack_public_path__ + "img/icon-preloading.b9f59814.svg";